import React from 'react';
import ConfiguracoesForm from './ConfiguracoesForm';
import TitleModule from '../../../components/title/TitleModule';

const Configuracoes = props => {
    const title = ["Configurações"];
    return (
        <>
            <TitleModule titulo={title.join(' > ')} />
            <ConfiguracoesForm />
        </>
    );
};

export default Configuracoes;